
$(document).ready(function () {
    //part10
    var swiper = new Swiper('.detail10 .swiper-container', {
      pagination: '.swiper-pagination',
      slidesPerView: 4,
      paginationClickable: true,
      spaceBetween: 30,
      prevButton: '.swiper-button-prev',
      nextButton: '.swiper-button-next',
    });
    $('.detail10 .swiper-button-prev').mouseover(function () {
      $(this).addClass('hv')
    })
    $('.detail10 .swiper-button-prev').mouseout(function () {
      $(this).removeClass('hv')
    })
    $('.detail10 .swiper-button-next').mouseover(function () {
      $(this).addClass('hv')
    })
    $('.detail10 .swiper-button-next').mouseout(function () {
      $(this).removeClass('hv')
    })

    $('.detail10 .swiper-slide').hover(function () {
      $(this).addClass('top')
    }, function () {
      $(this).removeClass('top')

    })
    setTimeout(function(){
      // document.addEventListener('DOMContentLoaded', function () {
          console.log('==定时器==');
              //part11
          var swiper = new Swiper('.detail11 .swiper-container', {
            pagination: '.swiper-pagination',
            slidesPerView: 4,
            paginationClickable: true,
            spaceBetween: 30,
            prevButton: '.swiper-button-prev',
            nextButton: '.swiper-button-next',
          });
          $('.detail11 .swiper-button-prev').mouseover(function () {
            $(this).addClass('hv')
          })
          $('.detail11 .swiper-button-prev').mouseout(function () {
            $(this).removeClass('hv')
          })
          $('.detail11 .swiper-button-next').mouseover(function () {
            $(this).addClass('hv')
          })
          $('.detail11 .swiper-button-next').mouseout(function () {
            $(this).removeClass('hv')
          })

          for(let i =0;i<$('.detail11 .swiper-slide').length ;i++){
  
            if(!$('.detail11 .swiper-slide').eq(i).find('.sp').html()){
              // console.log('====1===',$(this).find('.bor'))
            $('.detail11 .swiper-slide').eq(i).find('.bor').hide();
            // $('.detail11 .swiper-slide').eq(i).removeClass('top');
            }else{
              console.log('====2===')

            }
          }

          $('.detail11 .swiper-slide').hover(function () {
            $(this).addClass('Bo')

            // if(!$(this).find('.sp').html()){
            // console.log('====1===',$(this).find('.bor'))
            //   $(this).find('.bor').hide();
            // }else{
            //   console.log('====2===')

            // }
          }, function () {
            $(this).removeClass('Bo')

          })
          $('#az_reviews').addClass('nne');
      // })
    },2200)

});

// document.querySelector('.progress-bar').style.width = '85%';
$(document).ready(function () {
  // 给每个标题绑定点击事件
  $('.detail08  .policy-title').on('click', function () {
    // 找到当前标题对应的“policy-content”元素
    var content = $(this).next('.policy-content');
    // 切换显示状态：隐藏→显示，显示→隐藏
    content.slideToggle(); // 平滑切换（也可用 toggle()）
    $(this).toggleClass('zz01'); // 切换zz类
  });
   $('.detail01 .policy-title').on('click', function () {
    // 找到当前标题对应的“policy-content”元素
    var content = $(this).next('.policy-content');
    // 切换显示状态：隐藏→显示，显示→隐藏
    content.slideToggle(); // 平滑切换（也可用 toggle()）
    $(this).toggleClass('zz02'); // 切换zz类
  });
  // $('.policy-title').eq(0).click();
});
$('#orage').click(function () {
  $('.progress-bar').css('background', '#EE6E00')
})
$('#black').click(function () {
  $('.progress-bar').css('background', 'black')
})
$('#gray').click(function () {
  $('.progress-bar').css('background', 'gray')
})


//part2 ===视频
if( $(window).width() <768 ){
  console.log('移动端版本')
  console.log('=====2=====')
  // 包裹第一个li
  $('.detail01 .container .item:first-child').wrap('<div class="full-width-item"></div>');
    console.log('============1111')
  // 包裹其他li
  const otherLis = $('.detail01 .container .item:not(:first-child)');
  if (otherLis.length > 0) {
    // 创建滚动容器
    const scrollContainer = $('<div class="scroll-container"></div>');
    // 将其他li移动到滚动容器中
    otherLis.appendTo(scrollContainer);
    // 将滚动容器插入到ul中
    $('.detail01 .container').append(scrollContainer);
  }
}else{
  console.log('pc版本')
}
   






$(document).ready(function() {
    const $video = $('#myVideo');
    const $pauseIcon = $('#customPause');
    let flag = false;
    //PC
    $('#myVideo').click(function(e){  
      console.log('=====PC端视频处理======',$('#myVideo')[0].paused)
      // flag = $('#myVideo')[0].paused)
      if($('#myVideo')[0].paused){
        console.log('false===')
        $('#customPause').css('display', 'none')

      }else{
        console.log('==true==')
        $('#customPause').css('display', 'block')
      }
    })
  
    $('#customPause').click(function(){
      console.log('=====点击了蒙层===')
       $('#customPause').css('display', 'none')
       $('#myVideo')[0].play()

    })
    //移动端  
    if( $(window).width() <768 ){
      console.log('==移动端视频处理===')
      // 方案1：组合事件监听（移动端优先使用touch事件）
      const video = document.getElementById('myVideo');
      $('#myVideo').on('click touchend', function(e) {
          // 移动端特殊处理：阻止默认行为和事件冒泡
          if (/mobile/i.test(navigator.userAgent)) {
              e.preventDefault();
              e.stopPropagation();
          }
          console.log("视频宽度和高度",$('#myVideo').width(),$('#myVideo').height())
          $('#customPause').css({'width':$('#myVideo').width()+'px', 'height':$('#myVideo').height() +'px'})
            if($('#myVideo')[0].paused){
            console.log('false===')
            $('#customPause').css('display', 'none')

          }else{
            console.log('==true==')
            $('#customPause').css('display', 'block')
          }
          
          // 切换播放状态
          toggleVideoPlay(video);
      });
        function toggleVideoPlay(videoElement) {
          if (videoElement.paused) {
              videoElement.play().catch(e => console.log('播放失败:', e));
          } else {
              videoElement.pause();
          }
          // 强制触发事件更新状态 
          setTimeout(() => {
              const event = new Event('statuschange');
              videoElement.dispatchEvent(event);
          }, 100);
      }
      $('.detail06 .con .r .item').click(function(){
         $('.detail06 .con .r .item').removeClass('focus')
        $(this).addClass('focus')
      })
    }

})
//part4 
$('#cont p').click(function () {
  console.log('==点击了头部==', $(this).index())
  $('#cont p').removeClass('focus')
  $('#conb .pCon').removeClass('block')

  $(this).addClass('focus')
  $('#conb .pCon').eq($(this).index()).addClass('block')
})

//part5
$('.detail05 .con .r .item').hover(function () {
  $(this).addClass('hover')
}, function () {
  $(this).removeClass('hover')

})
//part8
$(document).ready(function () {
  // 绑定点击事件：点击标题时，切换对应内容的显示状态
  $('.accordion-title').click(function () {
    // 找到当前标题对应的“内容区域”，并切换显示/隐藏
    $(this).next('.accordion-content').slideToggle();
    $(this).toggleClass('toZZ'); // 切换zz类
  });
});

